<template>
    <div class="table-wrapper" style="padding-top: 24px">
        <div class="fchart-box" >
            <Row :gutter="24">
                <Col span="8">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">{{nowTear}}年人员总数统计</span>
                    </div>
                    <div class="fchart-bi" ref="numberBar">人数统计</div>
                </Col>
                <Col span="8">
                    <div class="aFlex fchart-box-top" style="position: relative">
                        <span class="ft-bold">年龄分布</span>
                        <!-- <span style="font-size: 12px;margin-left: 10px">
                            平均年龄：在岗<span class="ft-bold-blue">{{aveAgeWork}}</span>岁，
                            在册<span class="ft-bold-blue">{{aveAgeRegisted}}</span>岁
                        </span> -->
                        <div class="aFlex ft-top-rt">
                            <div class="main-credit-item"
                                 v-for="(item,index) in genders" :key="index"
                                 :class="{active:gender===item.value}"
                                 @click="handleGender(item.value)">{{item.label}}</div>
                        </div>
                    </div>
                    <div class="fchart-bi" ref="ageBar">年龄分布</div>
                </Col>
                <Col span="8">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">男女比例</span>
                    </div>
                    <div class="fchart-bi" ref="sexBar">男女比例</div>
                </Col>
            </Row>
        </div>
        <div class="fchart-box" >
            <Row :gutter="24">
                <Col span="8">
                    <div class="ajFlex fchart-box-top">
                        <span class="ft-bold">工种</span>
                        <Button type="primary"  size="small" @click="handleAll('workType')">查看全部</Button>
                    </div>
                    <Table border size="small" style="border-top: none"
                           :columns="workTypeColumns" :data="workTypeData" highlight-row>
                    </Table>
                </Col>
                <Col span="8">
                    <div class="ajFlex fchart-box-top">
                        <span class="ft-bold">地域</span>
                        <Button type="primary" size="small" @click="handleAll('area')">查看全部</Button>
                    </div>
                    <Table border size="small" style="border-top: none"
                           :columns="areatColumns" :data="areatData" highlight-row>
                    </Table>
                </Col>
                <Col span="8">
                    <div class="ajFlex fchart-box-top">
                        <span class="ft-bold">民族</span>
                        <Button type="primary" size="small" @click="handleAll('nation')">查看全部</Button>
                    </div>
                    <Table border size="small" style="border-top: none"
                           :columns="nationColumns" :data="nationData" highlight-row>
                    </Table>
                </Col>
            </Row>
        </div>
        <Modal v-model="allModel" footer-hide width="500">
            <p slot="header">
                <span>{{curType}}</span>
            </p>
            <Table border size="small" :loading="loading"
                   :columns="allColumns" :data="allData" highlight-row>
            </Table>
            <div class="t-page">
                <Page :total="totalCount" :page-size="pageSize" :current="page"
                      @on-change="changePage" @on-page-size-change="pageSizeChange"
                      show-elevator show-sizer show-total transfer>
                </Page>
            </div>
        </Modal>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                nowTear: '',
                /* 查看全部 */
                allModel:false,
                curType:'工种',
                allColumns: [],
                allData: [],
                wtype:1, // 默认工种
                totalCount:0, // 总数
                gender:'',
                genders:[
                    {label:'全部',value:''},
                    {label:'男性',value:1},
                    {label:'女性',value:2},
                ],
                aveAgeWork:'',
                aveAgeRegisted:'',
                workTypeColumns:[
                    {
                        title: '排名',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '工种',
                        key: 'key',
                        align:'center',
                    },
                    {
                        title: '人数',
                        key: 'value',
                        align:'center'
                    },
                    {
                        title: '占比',
                        key: 'proportion',
                        align:'center'
                    },
                ],
                workTypeData:[],
                areatColumns:[
                    {
                        title: '排名',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地域',
                        key: 'key',
                        align:'center',
                    },
                    {
                        title: '人数',
                        key: 'value',
                        align:'center'
                    },
                    {
                        title: '占比',
                        key: 'proportion',
                        align:'center'
                    },
                ],
                areatData:[],
                nationColumns:[
                    {
                        title: '排名',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '民族',
                        key: 'key',
                        align:'center',
                    },
                    {
                        title: '人数',
                        key: 'value',
                        align:'center'
                    },
                    {
                        title: '占比',
                        key: 'proportion',
                        align:'center'
                    },
                ],
                nationData:[],
                // 人数统计
                numberBar:null,
                // 年龄分布
                ageBar:null,
                // 男女比例
                sexBar:null,
                areaCode: localStorage.getItem('tenantAreaCode'),
            };
        },
        computed:{

        },
        watch: {
            areaCode: function () {
                this.getPageData();
            },
        },
        created(){
            this.nowTear = new Date().getFullYear();
        },
        mounted(){
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 人数统计
            this.numberBar = echarts.init(this.$refs.numberBar);
            // 年龄分布
            this.ageBar = echarts.init(this.$refs.ageBar);
            // 男女比例
            this.sexBar = echarts.init(this.$refs.sexBar);

            //初始化 setOption
            this.initChart();
            //获取数据
            this.getPageData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // 查看全部
            handleAll(type){
                switch (type) {
                    case 'workType':
                        this.curType='工种';
                        this.wtype=1;
                        this.allColumns=this.workTypeColumns;
                        break;
                    case 'area':
                        this.curType='地域';
                        this.wtype=2;
                        this.allColumns=this.areatColumns;
                        break;
                    case 'nation':
                        this.curType='民族';
                        this.wtype=3;
                        this.allColumns=this.nationColumns;
                        break;
                }
                this.page = 1
                this.pageSize = 10
                this.getTableData();
                this.allModel=true;
            },
            getTableData(){
                this.allData=[];
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryWorkerByType',
                    data:{
                        size:this.pageSize,
                        current:this.page,
                        areaCode:this.areaCode,
                        type:this.wtype
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data){
                        this.allData=response.data.data.map((item)=>{
                            return {
                                ...item,
                                proportion:item.proportion + "%"

                            }
                        });
                        this.totalCount=response.data.total;
                    }
                }).catch(()=>{
                    this.loading=false;
                });
            },
            // echarts 适应
            resize(){
                this.numberBar.resize();
                this.ageBar.resize();
                this.sexBar.resize();
            },
            initChart(){
                this.numberBar.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            icon:'rect',
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid:{
                            left: 16,
                            right: 16,
                            // top: 40,
                            // bottom: 5,
                            containLabel: true
                        },
                        xAxis:{
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis:{
                            name:'单位: 人',
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                }
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                        },
                        color: [ '#3399FF','#61DDAA','#65789B'],
                        series: [
                            {
                                type: 'bar',
                                name: '人数',
                                barMaxWidth: 28,
                                barMinWidth: 28,
                                data:[],
                            },
                        ]
                    }
                );
                this.ageBar.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            icon:'rect',
                            // data:['在岗比例%','在册比例%'],
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                             formatter(params) {
                                let str = '';
                                if(params) {
                                    let item = params[0];
                                    let item1 = params[1]
                                str = `<div>
                                        <div style="font-size: 14px;">
                                            <div>${item.axisValueLabel}</div>
                                            <div>${item.seriesName}：${item.data.value}${'%'}</div>
                                            <div>${item1.seriesName}：${item1.data.value}${'%'}</div>
                                        </div>
                                </div>`;
                                }else {
                                str = '';
                                }
                                return str;
                            },
                        },
                        grid:{
                            left: 16,
                            right: 16,
                            // top: 40,
                            // bottom: 5,
                            containLabel: true
                        },
                        xAxis:{
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis:{
                            name:'单位: %',
                            nameTextStyle:{
                                // align:'left',
                                // padding:[0]
                            },
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                }
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                        },
                        color: [ '#3399FF','#61DDAA','#65789B'],
                        series: [
                            {
                                type: 'bar',
                                name: '在岗比例',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'bar',
                                name: '在册比例',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                        ]
                    }
                );
                this.sexBar.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            left:'center',
                            icon:'rect',
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                             formatter(params) {
                            let str = '';
                            if(params) {
                                let item = params[0];
                                let item1 = params[1]
                            str = `<div>
                                <div style="font-size: 14px;">
                                    <div>${item.axisValueLabel}</div>
                                    <div>${item.seriesName}：${item.data.value}${'%'}</div>
                                    <div>${item1.seriesName}：${item1.data.value}${'%'}</div>
                                </div>
                            </div>`;
                            }else {
                            str = '';
                            }
                            return str;
                        },

                        },
                        grid:{
                            left: 16,
                            right: 16,
                            // top: 40,
                            // bottom: 5,
                            containLabel: true
                        },
                        xAxis:{
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis:{
                            name:'单位: %',
                            nameTextStyle:{
                                // align:'left',
                                // padding:[0]
                            },
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                }
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                        },
                        color: [ '#3399FF','#61DDAA','#65789B'],
                        series: [
                            {
                                type: 'bar',
                                name: '在岗比例',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'bar',
                                name: '在册比例',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                        ]
                    }
                );
            },
            // 页面初始化全量数据加载接口
            querySummaryWorkerProperty(){
                this.numberBar.showLoading();
                this.sexBar.showLoading();
                let personCount = [];
                let sexRatioMap = {};
                this.axios({
                    method: 'post',
                    url: `/summary/querySummaryWorkerProperty?areaCode=${this.areaCode}`,
                    data:{
                        areaCode:this.areaCode
                    }
                }).then( (response)=> {
                    this.numberBar.hideLoading();
                    this.sexBar.hideLoading();
                    if (response.data){
                        personCount=response.data.personCount;
                        sexRatioMap=response.data.sexRatioMap;
                        let pxData=[];
                        personCount.forEach(item=>{
                            pxData.push(item.name);
                        });
                        let sxData=['男性', '女性'];
                        // sexRatioMap.work.forEach(item=>{
                        //     sxData.push(item.name);
                        // });
                        this.numberBar.setOption(
                            {
                                xAxis:{
                                    data:pxData,
                                },
                                series: [
                                    {
                                        data:personCount,
                                    },
                                ]
                            }
                        );
                            this.sexBar.setOption(
                            {
                                xAxis:{
                                    data:sxData,
                                },
                                series: [
                                    {
                                        data:sexRatioMap.work || [],
                                    },
                                    {
                                        data:sexRatioMap.register || [],
                                    },
                                ]
                            }
                        );
                    }
                });
            },
            // 查询工种、区域、民族列表
            querySummaryWorkerByType(){
                let params={
                    size:10,
                    current:1,
                    areaCode:this.areaCode
                };
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryWorkerByType',
                    data:{
                        type:1,
                        ...params
                    }
                }).then( (response)=> {
                    if (response.data){
                        this.workTypeData=response.data.data.map((item)=>{
                            return {
                                ...item,
                                proportion:item.proportion + "%"

                            }
                        });
                    }
                });
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryWorkerByType',
                    data:{
                        type:2,
                        ...params
                    }
                }).then( (response)=> {
                    if (response.data){
                        this.areatData=response.data.data.map((item)=>{
                            return {
                                ...item,
                                proportion:item.proportion + "%"

                            }
                        });

                    }
                });
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryWorkerByType',
                    data:{
                        type:3,
                        ...params
                    }
                }).then( (response)=> {
                    if (response.data){

                        this.nationData=response.data.data.map((item)=>{
                            return{
                                ...item,
                                proportion:item.proportion + "%"
                            }
                        });
                    }
                });
            },
            // 性别改变
            handleGender(value){
                this.gender=value;
                this.queryDistributionForAge();
            },
            // 年龄分布区域查询
            queryDistributionForAge(){
                this.ageBar.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/queryDistributionForAge',
                    data:{
                        areaCode:this.areaCode,
                        gender:this.gender
                    }
                }).then( (response)=> {
                    this.ageBar.hideLoading();
                    if (response.data){
                        this.aveAgeWork=Number(response.data.aveAgeWork).toFixed(1);
                        this.aveAgeRegisted=Number(response.data.aveAgeRegisted).toFixed(1);
                        let ageDistribution=response.data.ageDistribution;
                        let xData=[];
                        ageDistribution.work.forEach(item=>{
                            if(item.value == null) {
                                item.value = 0
                            }
                            xData.push(item.name);
                        });
                        ageDistribution.register.map( item => {
                            if(item.value == null) {
                                item.value = 0
                            }
                        })
                        this.ageBar.setOption(
                            {
                                xAxis:{
                                    data:xData,
                                },
                                series: [
                                    {
                                        data:ageDistribution.work,
                                    },
                                    {
                                        data:ageDistribution.register,
                                    },
                                ]
                            }
                        );
                    }
                });
            },
            /* 获取页面数据 */
            getPageData(){
                this.querySummaryWorkerProperty();
                this.queryDistributionForAge();
                this.querySummaryWorkerByType();
            },
            pageSizeChange(val) {
                this.pageSize = val;
                this.getTableData();
            }
        }
    };
</script>
<style scoped>
    .ft-top-rt{
        margin-left: auto;
        /*position: absolute;*/
        /*right: 10px;*/
        /*bottom: 0;*/
    }
    .main-credit-item{
        padding: 0 10px;
        line-height: 50px;
        height: 50px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        transition: color .3s ease-in-out;
    }
    .main-credit-item.active{
        color: #0099FF;
        border-bottom-color: #0099FF;
    }
    .table-wrapper{
        padding: 0 24px;
        padding-bottom: 20px;
        background: white;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    }
    .fchart-box{
        /* margin-bottom: 30px; */
	    background-color: #ffffff;
    }
</style>
